<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="row">
      <div class="col-md-12" align="right">
        <base-button type="primary" @click="onNewClubClicked">New Club</base-button>
      </div>
      <div class="col-md-12 mt-4 mb-4">
        <club-info-table @edit="onEditClub" />
      </div>
      <modal
        :show.sync="showCreateUpdateClub"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
        @close="onCloseModal()"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <div class="col-md-12 text-center mb-4" id="file-input">
                <label>
                  <input type="file" @change="setImage" accept="image/*" />
                  <img class="avatar avatar-lg rounded-circle pointer-cursor" :src="clubLogo" alt />
                </label>
              </div>
              <!-- <label for="club-name" class="mb-1">Club Name</label> -->
              <span class="error" v-if="!clubName && !isInputValid">* field required</span>
              <base-input
                alternative
                placeholder="Club Name"
                v-model="clubName"
                @input="onInputChanged()"
              />

              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4"
                  @click="onCreateClicked()"
                  :disabled="isLoading"
                >{{club ? 'Update' : 'Create'}}</base-button>
              </div>
              <div class="col-md-12 text-center mt-5 mb-4" v-if="error">
                <span class="response-error">* {{ error.message }}</span>
              </div>
            </form>
          </template>
        </card>
      </modal>
    </div>
  </div>
</template>

<script>
import ClubInfoTable from '@/views/Club/ClubInfoTable'
import {
  UPLOAD_FILE,
  CREATE_CLUB,
  INVALID_CLUB_LOGO,
  GET_CLUB,
  UPDATE_CLUB
} from '@/store/actions.type'

import { mapState } from 'vuex'

const MAX_IMAGE_FILE_SIZE = 500 * 1000
const LOGO_SIZE = 128

export default {
  components: { ClubInfoTable },
  data() {
    return {
      clubLogo: require('@/assets/required_club_logo.png'),
      clubName: '',
      showCreateUpdateClub: false,
      isInputValid: true
    }
  },
  beforeDestroy() {
    this.$store.state.file.fileUrl = null
  },
  methods: {
    onNewClubClicked() {
      this.showCreateUpdateClub = true
    },
    setImage(e) {
      const file = e.target.files[0]
      e.target.value = ''
      if (file.size >= MAX_IMAGE_FILE_SIZE) {
        alert('Please select a smaller image size')
        return
      }
      const reader = new FileReader()
      const image = new Image()

      image.onload = () => {
        if (image.width !== image.height && image.width !== LOGO_SIZE) {
          this.$store.dispatch(INVALID_CLUB_LOGO)
          return
        }
        this.$store.dispatch(UPLOAD_FILE, { file, imageType: 'uploads' })
        this.clubLogo = image.src
      }
      reader.onload = event => {
        image.src = event.target.result
      }
      reader.readAsDataURL(file)
    },
    onCreateClicked() {
      if (this.clubName && this.clubLogoUrl) {
        let clubName = this.clubName
        let clubLogo = this.clubLogoUrl
        let action = CREATE_CLUB

        let body = {
          clubName: clubName,
          avatar: clubLogo
        }

        if (this.club) {
          action = UPDATE_CLUB
          body = {
            id: this.club.id,
            clubName: clubName,
            avatar: clubLogo
          }
        }
        this.$store.dispatch(action, body).then(club => {
          this.showCreateUpdateClub = false
          location.reload()
        })
      } else {
        if (!this.clubName) {
          this.isInputValid = false
        }
        if (!this.clubLogoUrl) {
          this.$store.dispatch(INVALID_CLUB_LOGO)
        }
      }
    },
    onCloseModal() {
      this.clubLogo = require('@/assets/required_club_logo.png')
      this.clubName = ''
      this.$store.state.club.club = null
      this.$store.state.club.error = null
    },
    onInputChanged() {
      this.$store.state.user.error = null
    },
    onEditClub(id) {
      this.$store.dispatch(GET_CLUB, id).then(club => {
        this.showCreateUpdateClub = true
        this.clubLogo = club.avatar
        this.clubName = club.clubName
        this.$store.state.club.clubLogoUrl = club.avatar
      })
    }
  },
  computed: {
    ...mapState({
      club: state => state.club.club,
      clubLogoUrl: state => state.file.fileUrl,
      isLoading: state => state.club.isLoading,
      error: state => state.club.error
    })
  }
}
</script>
<style scoped>
.avatar-lg {
  width: 100px !important;
  height: 100px !important;
}
</style>>
